<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-colour">
      <div
        v-if="isValidHexColour(value)"
        class="grid-field-colour__swatch"
        :style="{ backgroundColor: value }"
      ></div>
      <div class="grid-field-colour__text">
        <SearchHighlightedText :text="value" :search-term="searchTerm" />
      </div>
    </div>
  </div>
</template>

<script>
import { isValidHexColour } from '@baserow/modules/core/utils/string'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldColour',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    isValidHexColour,
  },
}
</script>
